import { combineReducers } from 'redux';
import byDrug from './brandSwapByDrug.reducer';

const brandSwapReducer = combineReducers({
  byDrug,
});

export default brandSwapReducer;
